import { useQueries } from '@tanstack/react-query';
import api from '../../api/api';
import { useUserStore } from '../../stores/userStore';
import { recordEndpoints, unwrapRecords } from '../../pages/mypage/components/myRecordsModel';
const resources = Object.keys(recordEndpoints);
export default function usePublicRecords(profile) {
  const viewer = useUserStore((state) => state.user);
  const enabled = profile?.id != null && !!profile.nickname;
  const mine = viewer?.id != null && String(viewer.id) === String(profile?.id);
  const privateTabs = {
    saved: !mine && profile?.showSavedOnProfile === false,
    comments: !mine && profile?.showCommentsOnProfile === false,
  };
  const queries = useQueries({
    queries: resources.map((resource) => ({
      queryKey: [
        'publicMusicRecords',
        viewer?.id ?? 'guest',
        profile?.id,
        profile?.nickname,
        resource,
        !!privateTabs[resource],
      ],
      queryFn: async ({ signal }) =>
        unwrapRecords(
          await api.getAuth(
            mine
              ? recordEndpoints[resource]
              : `/users/${encodeURIComponent(profile.nickname)}/${resource === 'albums' ? 'reviews' : resource === 'tracks' ? 'track-ratings' : resource}`,
            { signal },
          ),
        ),
      enabled: enabled && !privateTabs[resource],
      retry: false,
      gcTime: 0,
      staleTime: 0,
    })),
  });
  return {
    enabled,
    ownerId: mine ? viewer.id : undefined,
    privateTabs,
    queries: Object.fromEntries(resources.map((key, index) => [key, queries[index]])),
    // Mask synchronously, including cached data while privacy/account props change.
    data: Object.fromEntries(
      resources.map((key, index) => [
        key,
        enabled && !privateTabs[key] ? queries[index].data : undefined,
      ]),
    ),
  };
}
